import Glide from '@glidejs/glide'
import refs from '../helpers/refs'

class CAchievementsBlock {
  constructor (el) {
    this.$el = el
    this.$refs = refs(this.$el)

    this.init()
  }

  init () {
    this.glideSlider = new Glide(this.$refs.glide, {
      animationDuration: 8000,
      animationTimingFunc: 'linear',
      autoplay: 8000,
      bound: true,
      gap: 24,
      peek: 48,
      perView: 3,
      rewind: false,
      type: 'carousel',
      breakpoints: {
        1279: {
          gap: 16,
          peek: 32
        },
        1023: {
          gap: 16,
          peek: 32,
          perView: 2
        },
        639: {
          gap: 16,
          peek: 32,
          perView: 1
        }
      }
    }).mount()
  }
}

// Wait for images to load in
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-achievements-block]')
    .forEach(el => new CAchievementsBlock(el))
})
